// extracted by mini-css-extract-plugin
module.exports = {"details":"StepHeading_details__N6dio","title":"StepHeading_title__kTTeD","large":"StepHeading_large__wG6DA","description":"StepHeading_description__sAlX5"};